import {COOKIE_OID, getCookie} from '@utils/cookies';
import {safeLocalStorage} from '@utils/safeStorages';

import {OmicronConfigResponseType} from './types';

export const setOidSegments = <T extends Record<string, unknown>>(
  data: OmicronConfigResponseType<T>,
) => {
  if (data.segments) {
    safeLocalStorage.setItem('omicronParams', JSON.stringify(data.segments));
  }

  const userId = getCookie(COOKIE_OID);

  if (userId) {
    safeLocalStorage.setItem('userId', userId);
  }
};
